<template>
  <section class="hero">
    <div class="hero-content">
      <p class="eyebrow">互联网 + 运贸融一体化平台</p>
      <h1>博洛克供应链科技</h1>
      <p class="hero-copy">
        面向招采、数字货运、铜价资讯与供应链协同场景，提供更高效、更透明、更可持续的产业数字化服务。
      </p>
      <div class="hero-actions">
        <router-link class="primary-action" to="/AppSolution">查看应用方案</router-link>
        <a class="secondary-action" href="#products">了解产品能力</a>
      </div>
      <ul class="metrics" aria-label="平台能力">
        <li>
          <strong>4+</strong>
          <span>核心业务场景</span>
        </li>
        <li>
          <strong>24h</strong>
          <span>线上协同响应</span>
        </li>
        <li>
          <strong>全链路</strong>
          <span>供采运贸闭环</span>
        </li>
      </ul>
    </div>

    <div class="hero-visual" aria-hidden="true">
      <img src="@/assets/image/image.png" alt="" />
    </div>
  </section>
</template>

<script>
export default {
  name: "Banner",
};
</script>

<style lang="less" scoped>
.hero {
  position: relative;
  display: grid;
  grid-template-columns: minmax(320px, 0.9fr) minmax(420px, 1.1fr);
  align-items: center;
  gap: clamp(36px, 5vw, 72px);
  min-height: calc(100vh - 76px);
  padding: clamp(64px, 9vw, 116px) clamp(24px, 6vw, 96px) clamp(44px, 6vw, 80px);
  background:
    radial-gradient(circle at 80% 20%, rgba(17, 167, 217, 0.18), transparent 28%),
    linear-gradient(135deg, #f8fbff 0%, #edf5ff 48%, #ffffff 100%);
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 680px;
}

.eyebrow {
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 12px;
  color: #1268e8;
  font-size: 14px;
  font-weight: 700;
  background: #eaf3ff;
  border: 1px solid rgba(18, 104, 232, 0.14);
  border-radius: 6px;
}

h1 {
  margin-top: 22px;
  color: #101828;
  font-size: clamp(42px, 6vw, 72px);
  line-height: 1.04;
  font-weight: 800;
}

.hero-copy {
  max-width: 620px;
  margin-top: 24px;
  color: #475467;
  font-size: clamp(17px, 2vw, 21px);
  line-height: 1.8;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 34px;
}

.primary-action,
.secondary-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 0 22px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 6px;
}

.primary-action {
  color: #fff;
  background: linear-gradient(135deg, #176bff 0%, #11a7d9 100%);
  box-shadow: 0 16px 36px rgba(23, 107, 255, 0.24);
}

.secondary-action {
  color: #176bff;
  background: #fff;
  border: 1px solid rgba(23, 107, 255, 0.18);
}

.metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  max-width: 560px;
  margin-top: 44px;

  li {
    padding: 18px;
    background: rgba(255, 255, 255, 0.72);
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 8px;
    box-shadow: 0 14px 36px rgba(15, 23, 42, 0.06);
  }

  strong,
  span {
    display: block;
  }

  strong {
    color: #101828;
    font-size: 26px;
    line-height: 1;
  }

  span {
    margin-top: 10px;
    color: #667085;
    font-size: 14px;
  }
}

.hero-visual {
  position: relative;
  z-index: 1;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 30px 70px rgba(16, 24, 40, 0.18);

  img {
    display: block;
    width: 100%;
    min-height: 420px;
    object-fit: cover;
    object-position: center;
  }
}

@media screen and (max-width: 1080px) {
  .hero {
    grid-template-columns: 1fr;
    min-height: auto;
  }

  .hero-visual img {
    min-height: 320px;
  }
}

@media screen and (max-width: 640px) {
  .hero {
    padding-left: 18px;
    padding-right: 18px;
  }

  .metrics {
    grid-template-columns: 1fr;
  }

  .primary-action,
  .secondary-action {
    width: 100%;
  }
}
</style>
